import AppConstants from "../constants/AppConstants";
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    count: 0,
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case AppConstants.INFO_DOCS_LOADING_START: {
            return {
                ...state,
                loading: true
            }
        }
        case AppConstants.INFO_DOCS_SET: {
            return {
                ...state,
                loading: false,
                list: payload.items,
                page: payload.page,
                count: payload.count,
                total: getTotalPages(payload.total, payload.count)
            }
        }
        case AppConstants.INFO_DOCS_LOADING_FAIL: {
            return {
                ...state,
                loading: false
            };
        }
        default:
            return state;
    }
}
